import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { fetchCatalogItems } from 'entities/CatalogItem/model/services/fetchCatalogItems/fetchCatalogItems';
import { catalogItemActions } from 'entities/CatalogItem/model/slices/CatalogItemSlice';
import { getSelectedCategoryIdToFetch } from 'entities/Category/model/selectors/categorySelectors';
import { getSearchLocalCatalogItemValue } from 'features/SearchCatalogItems/model/selectors/searchCatalogItemsSelectors';

import {
    RemoveCatalogItemRequestBody,
    RemoveCatalogItemResponse,
} from '../types/RemoveCatalogItemSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const removeCatalogItemService = createAsyncThunk<
    RemoveCatalogItemResponse,
    RemoveCatalogItemRequestBody,
    ThunkConfig<any>
>(
    'catalogItem/removeFromCatalog',
    async ({ data, catalogId, isSingle }, thunkApi) => {
        const { extra, rejectWithValue, dispatch, getState } = thunkApi;

        try {
            const response = await extra.api.delete<RemoveCatalogItemResponse>(
                `/v1/catalogs/${catalogId}/items`,
                { data },
            );

            const dataToRemove = response.data.removed.map(
                (item) => item.itemUuid,
            );

            if (isSingle) {
                if (dataToRemove.length) {
                    dispatch(
                        catalogItemActions.removeSingleItemByUidFromSelection(
                            dataToRemove[0],
                        ),
                    );
                }

                dispatch(catalogItemActions.closeDetailedItem());
            } else {
                dispatch(catalogItemActions.removeAllSelection());
            }

            dispatch(catalogItemActions.removeMultipleItemsByUid(dataToRemove));

            const categoryId = getSelectedCategoryIdToFetch(getState());
            if (categoryId) {
                dispatch(
                    fetchCatalogItems({ data: { catalogId, categoryId } }),
                );
            } else {
                const searchStr = getSearchLocalCatalogItemValue(getState());
                if (searchStr) {
                    dispatch(
                        fetchCatalogItems({ data: { catalogId, searchStr } }),
                    );
                }
            }

            toast(
                isSingle
                    ? 'Item removed from catalog'
                    : 'Items removed from catalog',
            );

            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
